import BalanceHandle from '@/pages/handle/balanceHandle'
import CheckDetail from '@/pages/handle/balanceHandle/CheckDetail'

export default [
  {
    path: '/balanceHandle',
    name: 'BalanceHandle',
    component: BalanceHandle,
    meta: { name: '返佣处理' }
  },
  {
    path: '/balanceHandle/checkDetail/:orderId',
    name: 'HandleCheckDetail',
    component: CheckDetail,
    props: true,
    meta: { name: ['返佣处理', '返佣详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/balanceHandle.js